import { render, staticRenderFns } from "./Trailer-detail.vue?vue&type=template&id=2afb352b&scoped=true&"
import script from "./Trailer-detail.vue?vue&type=script&lang=js&"
export * from "./Trailer-detail.vue?vue&type=script&lang=js&"
import style0 from "./Trailer-detail.vue?vue&type=style&index=0&id=2afb352b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb352b",
  null
  
)

export default component.exports